<template>
  <div class="container-fluid p-0">
    <!-- <h2 class="heading">fiifi</h2>
    <div class="row" style="width:100%">
      <div class="col-xl-8 col-lg-8 col-md-9 col-sm-3 col-0 bckGrdImg"></div>
      <div class="col-xl-4 col-lg-4 col-md-3 col-sm-4 col-12">
        <div class="trnsCls">
          <h3 class="wlcmTxt">Forgot Password</h3>
          <b-alert
            :show="message.length>0?true:false"
            :variant="variant"
            dismissible
            @dismissed="message=''"
          >{{message}}</b-alert>
          <form autocomplete="off" @submit.prevent="frgtPswdSubmit">
            <span class="forgtTxt" style="float:left;">Email</span>
            <input
              type="email"
              class="form-control inputGapCls"
              v-model="frgtPswd.email"
              autocomplete="off"
              required
              placeholder="Enter Email"
            />
            <div v-if="codeSubmit">
              <span class="forgtTxt" style="float:left;">Code</span>
              <input
                type="number"
                class="form-control inputGapCls"
                v-model="frgtPswd.code"
                required
                placeholder="Enter code"
              />
              <span class="forgtTxt" style="float:left;">Password</span>
              <input
                type="password"
                class="form-control inputGapCls"
                v-model="frgtPswd.pswd"
                required
                @keyup="passwordValidation"
                placeholder="Enter Password"
              />
              <small
                class="text-danger"
                v-if="!valid"
              >Password must be minimum of 8 characters, it should be alpha numeric and have at least one special character.</small>
              <p style="margin-top: 10px;"></p>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                <button :disabled="!valid" type = ""  class="lgnBtn">
                  Submit
                  <b-spinner v-if="isSubmit" style="float: right;" small label="Loading..."></b-spinner>
                </button>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                <button class="crtAcntBtn" @click="login">Login</button>
              </div>
            </div>
            <div class="row">
              
              <span style="margin-left:6%;margin-top:3%">Or Continue with</span>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12">
                
                <a :href="googleUrl">
                  <img src="static/img/google-icon.png" class="lgnIcns" />
                </a>
                <a :href="linkedinUrl">
                  <img src="static/img/link-icon.png" class="lgnIcns" />
                </a>
                <a :href="twitterUrl">
                  <img src="static/img/twitter-icon.png" class="lgnIcns" />
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-sm-5 col-0"></div>
    </div>-->
    <div class="loginBackgroundImage" style="min-height:100vh;height:auto">
      <div class="row m-0 p-0" style="width:100%;padding-top:30px">
        <div
          class="row mr-0 ml-0 d-flex justify-content-center w-100"
          style="margin-top: 60px;margin-bottom: 30px;"
        >
          <div class="heading">fiifi</div>
        </div>
        <div class="col-12 d-flex justify-content-center align-items-center">
          <div class="loginPopup">
            <div class="loginPopupLayout">
              <div class="loginTitle">Account Recovery</div>
              <b-alert
                :show="message.length>0?true:false"
                :variant="variant"
                dismissible
                @dismissed="message=''"
              >{{message}}</b-alert>
              <div>
                <form autocomplete="off" @submit.prevent="frgtPswdSubmit">
                  <span class="forgtTxt" style="float:left;padding-bottom:5px">Email</span>
                  <input
                    type="email"
                    class="form-control inputSignUpWrapper"
                    v-model="frgtPswd.email"
                    autocomplete="off"
                    required
                    placeholder="Enter Email"
                    @keyup="checkEmail"
                  />
                  <div v-if="codeSubmit">
                    <span class="forgtTxt" style="float:left;padding-bottom:5px">Code</span>
                    <input
                      type="number"
                      class="form-control inputSignUpWrapper"
                      v-model="frgtPswd.code"
                      required
                      placeholder="Enter code"
                    />
                    <span class="forgtTxt" style="float:left;padding-bottom:5px">Password</span>
                    <input
                      type="password"
                      class="form-control inputSignUpWrapper"
                      v-model="frgtPswd.pswd"
                      required
                      @keyup="passwordValidation"
                      placeholder="Enter Password"
                    />
                    <small
                      class="text-danger"
                      v-if="!valid"
                    >Password must be minimum of 8 characters, it should be alphanumeric and have at least one uppercase and one special character.</small>
                  </div>
                  <div class="d-flex" style="margin-bottom:20px;margin-top:20px">
                    <div class="flex-grow-1"></div>
                    <div>
                      <button
                        :disabled="!valid"
                        type="submit"
                        class="todo-form-submit-button btn btn-primary mb-0"
                      >
                        Submit
                        <b-spinner v-if="isSubmit" style="float: right;" small label="Loading..."></b-spinner>
                      </button>
                    </div>
                  </div>
                </form>
                <div class="loginAboveIconsText">Or you can Login with</div>
                <div class="d-flex justify-content-center" style="margin-top:17px">
                  <div style="margin-right:17px;margin-top: 3px;">
                    <a :href="googleUrl">
                      <img src="static/img/google-icon.png" class />
                    </a>
                  </div>
                  <div style="margin-right:17px">
                    <a :href="linkedinUrl">
                      <img src="static/img/link-icon.png" class />
                    </a>
                  </div>
                  <div style="margin-right:17px">
                    <a :href="twitterUrl">
                      <img src="static/img/twitter-icon.png" class />
                    </a>
                  </div>
                  <div class="ltseBtnDiv">
                    <a :href="ltseUrl">
                      <img src="static/img/ltse.png" class="suggestImage" />
                    </a>
                  </div>
                </div>
                <div style="margin-top:17px;">
                  <div class="newToFiifi">
                    New to fiifi?
                    <span style="color:#5445F3;cursor:pointer;" @click="signup">Sign Up</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "../../../../config/settings";
import api from "../../../axios_api";
export default {
  data() {
    return {
      frgtPswd: {},
      message: "",
      variant: "",
      isSubmit: false,
      facebookUrl: "",
      googleUrl: "",
      valid: false,
      twitterUrl: "",
      linkedinUrl: "",
      codeSubmit: false,
      ltseUrl: "",
    };
  },
  mounted() {
    this.facebookUrl = `//${config.URL}/api/auth/facebook`;
    this.googleUrl = `//${config.URL}/api/auth/google`;
    this.twitterUrl = `//${config.URL}/api/auth/twitter`;
    this.linkedinUrl = `//${config.URL}/api/auth/linkedin`;
    this.ltseUrl = `//${config.URL}/api/auth/ltse`;
  },
  methods: {
    login(e) {
      e.preventDefault();
      this.$router.push("/login");
    },
    passwordValidation() {
      let data = this.checkPassword(this.frgtPswd.pswd);
      if (data && this.frgtPswd.email) this.valid = true;
      else this.valid = false;
    },
    checkPassword(str) {
      var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z]).{8,}$/;
      return re.test(str);
    },
    frgtPswdSubmit(e) {
      e.preventDefault();
      this.isSubmit = true;
      this.valid = false;
      if (this.frgtPswd.email) {
        let username = this.frgtPswd.email;
        let lowerCaseEmail = this.frgtPswd.email.toLowerCase();
        if (!this.codeSubmit) {
          api
            .get(`/forgotPasswordEmailCheck/${lowerCaseEmail}`)
            .then((data) => {
              if (data.data.data.length > 0) {
                this.$Amplify.Auth.forgotPassword(username)
                  .then((data) => {
                    this.$toaster.success(
                      "Verification code has been sent to your email. Please enter the code to change password"
                    );
                    this.codeSubmit = true;
                    this.isSubmit = false;
                    this.valid = false;
                  })
                  .catch((err) => {
                    this.isSubmit = false;
                    this.variant = "danger";
                    this.valid = false;
                    this.message = err.message;
                  });
              } else {
                this.$toaster.error(
                  "Email not found. Please signup to create an account"
                );
                this.isSubmit = false;
                this.valid = false;
              }
            })
            .catch((error) => {
              this.$toaster.error(
                "Unable to process request, please try again"
              );
            });
        } else {
          let code = this.frgtPswd.code;
          let new_password = this.frgtPswd.pswd;
          this.$Amplify.Auth.forgotPasswordSubmit(username, code, new_password)
            .then((data) => {
              this.isSubmit = false;
              this.$router.push("/login");
            })
            .catch((err) => {
              this.isSubmit = false;
              this.variant = "danger";
              this.message = err.message;
            });
        }
      }
    },
    signup(e) {
      e.preventDefault();
      this.$router.push("/signup");
    },
    validateEmail(elementValue) {
      let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailPattern.test(elementValue);
    },
    checkEmail() {
      let check = this.validateEmail(this.frgtPswd.email);
      if (check) {
        this.valid = true;
      } else {
        this.valid = false;
      }
    },
  },
};
</script>
<style >
</style>